module.exports = __webpack_public_path__ + "static/media/logo_footer.05ee8544.png";